import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultEntitiesExportFieldNames } from "~pages/Entities/EntitiesListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportEntities = () => {
  const { sport = "", organizationId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultEntitiesExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/entities/export`, {
        method: "POST",
        body,
      });
    },
  });
};
